import { createPinia } from 'pinia'

export const pinia = createPinia()

// Export all stores for easy importing
export { useAuthStore } from './auth'
export { useCompanyStore } from './company'
export { useGeneralStore } from './general'
export { useInvestorStore } from './investor'
export { useMediaStore } from './media'
